<template>
  <div class="contract-detail">
    <div class="contract-title">
      <div class="contract-back" @click="goback">
        返回
      </div>
      <div class="contract-download">
        <Button type="primary" @click="confirmSign">立即签署</Button>
      </div>
    </div>
    <div class="contract-box">
      <div class="canvas-box" id="canvasBox" ref="canvasBox">

        <div class="pageContainer" @drop="droparea($event)" @dragover="allowDrop($event)" v-for="v in pdf.totalNum"
          :key="v" :style="{ width: pdf.width + 'px', height: pdf.height + 'px' }">
          <canvas :id="'canvas' + v" :data-page="v" class="contract-canvas"></canvas>
          <mySignature v-for="(signer, inds) in signAreaArr" v-if="signer.num == v || signer.sType == 2" :key="inds"
            :index="inds" :w="signer.width" :h="signer.height" :x="signer.realx" :y="signer.realy" :parent="true"
            :resizable="false" @dragging="OriginonDrag" :checkMar="signer.sType" :style="{
              borderColor: '#4680FF',
              fontSize: signer.fontSize + 'px',
              lineHeight: signer.height + 'px',
              color: '#4680FF',
              borderStyle: signer.actived ? 'solid' : 'dashed'
            }">
            <div class="delete-sign">
              <span @click="deleteEditArea(signer, inds)">×</span>
            </div>
            <!-- <div style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
              签署区域
            </div> -->
            <div class="signer-box" draggable="false" :style="{
              width: signer.width + 'px',
              height: signer.height + 'px',
              backgroundSize: signer.height + 'px',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '0%',
              backgroundImage: `url(${signer.sealurl})`
            }">
              <!-- <img :src="signer.sealurl" draggable="false" alt=""> -->
            </div>
          </mySignature>
        </div>
      </div>

      <div class="right" v-if="$route.query.tab != 'approve'">
        <div>
          <div class="title">
            <div class="right-title">
              <span>合同签章</span>
            </div>
          </div>
          <div class="container">
            <div class="signature-box" ref="signatrueBox" draggable="true" @dragstart="rightDragStart(1, $event)">
              <img :src="sealUrl" draggable="false" alt="">
            </div>
          </div>
          <div class="title">
            <div class="right-title">
              <span>骑缝章</span>
            </div>
          </div>
          <div class="container">
            <div class="signature-box" ref="signatrueBox1" draggable="true" @dragstart="rightDragStart(2, $event)">
              <img :src="sealUrl" draggable="false" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PDFVIEW from "@/utils/pdf.js"
import mySignature from "@/components/editor-element/draggingElements.vue";
export default {
  name: 'contract-detail',
  components: {
    mySignature
  },
  data() {
    return {
      pdf: {},
      contractInfo: {},

      isRightDrag: false,
      scale: 1,
      sealUrl: 'https://huluwa-ec.oss-accelerate.aliyuncs.com/png/3ca0b352ece1461d99eab12a0d46c207.png?Expires=4782675698&OSSAccessKeyId=LTAI4FyD2G3pks8QMgMDFmJV&Signature=KPl%2BP1F8saUwI%2F0XM8LJEONaTHE%3D',
      signAreaArr: [],
      screenX: 0,
      screenY: 0,
      actived: 1,
      signW: 126, //签名的宽度
      inputH: 126, //签名的宽度
      A4imgH: 841.92, //后台A4纸高度
      A4imgW: 595.32, //后台A4纸高度
      imgW: '',
      imgH: '',
      signtype: 1,
    }
  },
  watch: {
    'pdf.cacheNum': {
      handler: (n) => {
      },
      deep: true
    }
  },
  mounted() {
    this.contractInfo = {}

    this.getApprovaldetail();
    this.$refs.signatrueBox.oncontextmenu = function () {
      return false;
    }
    this.$refs.signatrueBox1.oncontextmenu = function () {
      return false;
    }
    this.$refs.canvasBox.oncontextmenu = function () {
      return false;
    }
  },
  methods: {
    //  获取签章
    getApprovaldetail() {
      this.pdf = new PDFVIEW.PDFVIEW('#canvasBox', {
        scale: this.scale,
        // pdfurl: 'https://sign-online-group.oss-cn-hangzhou.aliyuncs.com/sign-open/documentPdf/%E7%A4%BA%E4%BE%8B%E6%96%87%E4%BB%B6/guanjianci.pdf',
        pdfurl: 'https://tj-metalv.oss-cn-beijing.aliyuncs.com/lawfirm/uploads/20260305/55_律所介绍信_20260305160513.pdf'
      })
      let self = this;
      this.pdf.on("complete", function () {
        self.imgW = self.pdf.width
        self.imgH = self.pdf.height
      })
    },

    //签章的区域内移动
    OriginonDrag(x, y, index) {
      this.isRightDrag = false;
      //记录鼠标位置
      this.screenX = x;
      this.screenY = y;
      this.signAreaArr[index].realx = this.screenX;
      this.signAreaArr[index].realy = this.screenY;
    },
    // 删除移动区域
    deleteEditArea(obj, i) {
      if (obj) {
        this.signAreaArr.splice(i, 1);
      }
    },
    // 添加签章
    rightDragStart(item, e) {
      let userAgent = navigator.userAgent;
      let isFF = userAgent.indexOf("Firefox") > -1;
      if (isFF) {
        e.dataTransfer.setData("imgInfo", e.target.id); // 火狐拖拽必须携带数据
      }
      if (item == 2 && this.signAreaArr.filter(v => v.sType == 2).length > 0) {
        this.$Message.warning("合同中已有骑缝章！");
        return false
      }
      this.signtype = item;
      this.isRightDrag = true;
    },
    allowDrop(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    droparea(e) {
      if (this.isRightDrag) {
        this.signclc(e);
        this.isRightDrag = false;
      }
    },
    /**
     * 点击添加签名
     * @param item
     * @param index
     * @param e 如果是右侧拖拽则传入该事件
     */
    signclc(e) {
      if (!e) return;
      this.actived = e.target.getAttribute("data-page") || 1;

      let areaObj = {
        indexActived: e.target.getAttribute("data-page") || 1,
        num: this.actived,
        sType: this.signtype,
        realx: 0,
        realy: 0,
        height: 120 * this.scale,
        width: this.signtype == 2 ? (120 * this.scale / 2) : 120 * this.scale,
        sealurl: this.sealUrl
      };

      if (!e) {
        areaObj.realx = 326;
        areaObj.realy = 20;
      } else {
        if (e.offsetX >= this.imgW - this.signW / 2) {
          //鼠标移动的位置 大于右边边界位置；防止签名区域超出右边界
          areaObj.realx = this.imgW - this.signW; //放置在右边界
        } else if (e.offsetX <= this.signW / 2) {
          //小于左边边界位置
          areaObj.realx = 0; //放置在左边界
        } else areaObj.realx = e.offsetX - this.signW / 2; //如果签名位置没有超出边界的话就以鼠标在中间为基准

        if (e.offsetY >= this.imgH - this.inputH / 2) {
          areaObj.realy = this.imgH - this.inputH;
        } else if (e.offsetY <= this.inputH / 2) {
          areaObj.realy = 0;
        } else {
          areaObj.realy = e.offsetY - this.inputH / 2;
        }
      }
      if (this.signtype == 2) {
        areaObj.realx = this.imgW - areaObj.width;
      }

      if (e.target.nodeName == "CANVAS") {
        this.signAreaArr.push(areaObj);
      }
    },
    // 签署
    confirmSign() {
      if (this.signAreaArr.length <= 0) {
        this.$Message.warning("请您至少拖拽一个签章！");
        return false;
      }

      let params = {
        positionList: [],
      }
      this.signAreaArr.forEach(item => {
        let o = {
          leftBottomX: item.realx / this.scale,
          leftBottomY: (this.A4imgH - item.height / this.scale - item.realy / this.scale),
          num: item.num
        }
        if (item.sType == 2) {
          params.height = o.leftBottomY
        }
        if (item.sType != 2) {
          params.positionList.push(o)
          // return o
        }
      })
      console.log(params)
    },

    goback() {

    },
  }
}
</script>
<style>
.canvas-box {
  height: calc(100vh - 90px);
}

.right {
  height: calc(100vh - 50px);
}
</style>
<style scoped="scoped">
.contract-detail {
  height: 100vh;
  background: #f4f4f7;
}

.contract-detail .contract-title {
  height: 50px;
  background: #fff;
  line-height: 50px;
  padding: 0 18px;
  box-shadow: 0 5px 5px 5px #eee;
  display: flex;
  justify-content: space-between;
}

.contract-detail .contract-title .contract-back {
  width: 50px;
  cursor: pointer;
}

.contract-detail .contract-title .contract-download {
  color: #4680FF;
}

.contract-detail .contract-box {
  display: flex;
  justify-content: space-between;
}

.contract-detail .contract-box .canvas-box {
  overflow: auto;
  width: 100%;
  margin: 20px auto;
}

.contract-detail .contract-box .canvas-box .pageContainer {
  margin: 0 auto;
  position: relative;
}

.contract-detail .contract-box .canvas-box .contract-canvas {
  margin: 0 auto;
}

.contract-detail .contract-box .right {
  background-color: #FFFFFF;
  width: 308px;
  position: relative;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
}

.contract-detail .contract-box .right>div {
  width: 100%;
}

.contract-detail .contract-box .right .title {
  margin: 10px 20px;
  color: #888888;
}

.contract-detail .contract-box .right .title .right-title {
  height: 22px;
  line-height: 22px;
  border-left: 3px solid #4680FF;
}

.contract-detail .contract-box .right .title .right-title span {
  color: #333333;
  font-weight: bold;
  font-size: 18px;
  padding-left: 0.5rem;
}

.contract-detail .contract-box .right .signature-btn {
  width: 100%;
  padding: 0 20px;
  margin: auto;
}

.contract-detail .contract-box .right .signature-btn button {
  width: 100%;
  height: 30px;
  margin-bottom: 20px;
}

.contract-detail .contract-box .right .container {
  margin: 30px 20px;
}

.contract-detail .contract-box .right .container .signature-box {
  width: 180px;
  height: 180px;
  border: 1px solid #efefef;
  margin: 0 auto;
  text-align: center;
  line-height: 180px;
}

.contract-detail .contract-box .right .container .signature-box img {
  width: 100%;
  vertical-align: middle;
}

.contract-detail .vdr {
  outline: none;
}

.contract-detail .signer-box img {
  width: 100%;
}

.contract-detail .delete-sign {
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 16px;
  font-size: 18px;
  font-weight: 500;
  border-radius: 100%;
  position: absolute;
  color: #4680ff;
  right: -10px;
  top: -11px;
  z-index: 999;
  cursor: pointer;
  display: none;
  border: 1px solid #4680ff;
}

.contract-detail .vdr:hover .delete-sign {
  display: block;
}
</style>